import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Email pattern validator
 * @returns
 */
export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const EMAIL_REGEXP =
      /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
    if (
      control.value &&
      (control.value.length <= 5 || !EMAIL_REGEXP.test(control.value))
    ) {
      return { email: true };
    }

    return null;
  };
}
